var map = {
	"./": "2a72",
	"./development": "ae10",
	"./development.js": "ae10",
	"./index": "2a72",
	"./index.js": "2a72",
	"./production": "9dd3",
	"./production.js": "9dd3",
	"./sit": "2b12",
	"./sit.js": "2b12"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1867";